import * as Rollbar from 'rollbar'
import { Injectable, Inject, InjectionToken, ErrorHandler } from '@angular/core'
import { environment } from '@consumer/environments/environment'
import { deployInfo } from './deploy-info'

const rollbarConfig: Rollbar.Configuration = {
  enabled: environment.env !== 'dev', // Don't emit when developing on local
  accessToken: deployInfo.rollbar.webPostToken,
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: environment.env,
    // server: {
    //   root: 'webpack:///./',
    // },
    client: {
      javascript: {
        source_map_enabled: true, // true by default

        // -- Add this into your configuration ---
        code_version: deployInfo.commitSha,
        // ---------------------------------------

        // Optionally have Rollbar guess which frames the error was
        // thrown from when the browser does not provide line
        // and column numbers.
        guess_uncaught_frames: true,
      },
    },
  },
}

export function rollbarFactory() {
  return new Rollbar(rollbarConfig)
}
